import moment from "moment";
import React, { useEffect } from "react";
import { useHorizontalScroll } from "../../../../../hooks/useHorizontalScroll";
import { getModifiers } from "../../../../../utils/annual-planner-helpers";
import {
  AthleteStatsHeader,
  EventsRowHeader,
  MonthColumn,
  PhaseRowHeader,
} from "./";

export const CalendarView = ({
  weekDays,
  phases,
  calendarEvents,
  athleteStatsHeaders,
  dateFromState,
  startingCalendarDay,
  selectedDaysState,
  setSelectedDaysState,
  phasesAttachments,
  handlePhaseSelection,
  phasesDescriptions,
  setHorizontalScrollRef,
  athleteStatsState,
  athleteVolumesState,
}) => {
  // Getting the modifiers for the react-day-picker
  // These modifiers represent the events shown in the calendar
  const { modifiers, modifiersStyles, modifiersClassNames } =
    getModifiers(calendarEvents);

  //   Horizontal scroll for the calendar view
  const horizontalScrollRef = useHorizontalScroll("faster");

  useEffect(() => {
    setHorizontalScrollRef(horizontalScrollRef);
  }, []);

  return (
    <React.Fragment>
      <div role="planner-headers">
        <div className="month-row-header">
          {weekDays.map((day, index) => (
            <span className="row-header" key={`week-day-${day}-${index}`}>
              {day.day}
            </span>
          ))}
        </div>
        <PhaseRowHeader phases={phases} />
        <div className="phases-descriptions-header">
          <span className="row-header">Phase Description</span>
        </div>
        {!!calendarEvents.length && (
          <EventsRowHeader calendarEvents={calendarEvents} />
        )}

        <AthleteStatsHeader athleteStatsHeaders={athleteStatsHeaders} />
      </div>
      <div role="planner-body" ref={horizontalScrollRef}>
        {Array.apply(null, { length: 12 }).map((e, i) => {
          const monthDate = moment(dateFromState).add(i, "months");
          return (
            // The columns represent the entire column corresponding to one month
            // This includes the Training Phases, the Events, the Athlete Data. All in a column
            <MonthColumn
              key={`month-column-${i}-${Math.random().toString(16).slice(2)}`}
              month={monthDate}
              startingCalendarDay={startingCalendarDay}
              selectedDaysState={selectedDaysState}
              setSelectedDaysState={setSelectedDaysState}
              modifiers={modifiers}
              modifiersStyles={modifiersStyles}
              modifiersClassNames={modifiersClassNames}
              phases={phases}
              phasesAttachments={phasesAttachments}
              handlePhaseSelection={handlePhaseSelection}
              phasesDescriptions={phasesDescriptions}
              calendarEvents={calendarEvents}
              athleteStatsState={athleteStatsState}
              athleteVolumesState={athleteVolumesState}
            />
          );
        })}
      </div>
    </React.Fragment>
  );
};
